<template>
  <span>
    <button
      v-bind="$attrs"
      v-if="!href && !to"
      :type="type"
      :disabled="showIndicator || disabled"
      :class="`c-button btn btn-${size} btn-link action-${theme} ${className}`"
      @click="$emit('click')"
      data-type="button"
    >
      <div class="button-preloader" v-if="showIndicator">
        <span class="button-preloader__dot"/>
        <span class="button-preloader__dot"/>
        <span class="button-preloader__dot"/>
      </div>

      <span :class="`text-${theme}`" :style=" showIndicator ? 'opacity: 0;' : 'opacity: 1;'">
        <i v-if="icon" :class="`fa-regular ${icon}`"></i>
        <span :class="{'hidden-xs': hiddenXs, 'hidden-sm': hiddenSm}">
          <slot></slot>
        </span>
     </span>
    </button>

    <a
      v-bind="$attrs"
      v-if="href"
      :href="href"
      :class="`btn btn-${size} btn-link action-${theme} ${className}`"
      @click="$emit('click')"
    >
    <span :class="`text-${theme}`">
        <i v-if="icon" :class="`fa-regular ${icon || ''}`"></i>
        <span :class="{'hidden-xs': hiddenXs, 'hidden-sm': hiddenSm}">
          <slot></slot>
        </span>
     </span>
    </a>

    <router-link
      v-if="to"
      v-bind="$attrs"
      :to="to"
      :class="`btn btn-${size} btn-link action-${theme} ${className}`"
      @click="$emit('click')"
    >
    <span :class="`text-${theme}`">
        <i v-if="icon" :class="`fa-regular ${icon || ''}`"></i>
        <span :class="{'hidden-xs': hiddenXs, 'hidden-sm': hiddenSm}">
          <slot></slot>
        </span>
     </span>
    </router-link>
  </span>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'sm'
    },
    type: {
      type: String,
      default: 'button'
    },
    to: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    showIndicator: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hiddenXs: {
      type: Boolean,
      default: true
    },
    hiddenSm: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.inheritTextColorForDot()
  },
  methods: {
    inheritTextColorForDot() {
      const color = $('[data-type=button]').css('color')
      $('[data-type=button]').find('.button-preloader__dot').css({backgroundColor: color})
    }
  }
}
</script>

<style lang="scss" scoped>
.c-button {
  position: relative;

  &:hover{
    text-decoration: none;
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.button-preloader {
  display: flex;
  position: absolute;
  top: calc(50% - 6px);
  left: calc(50% - 18px);

  .button-preloader__dot {
    border-radius: 6px;
    display: block;
    width: 6px;
    height: 6px;
    margin: 3px;
    background-color: #4f4f4f;

    &:first-child {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-iteration-count: infinite;
    }

    &:nth-child(2) {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-delay: 0.1s;
      animation-iteration-count: infinite;
    }

    &:last-child {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-delay: 0.2s;
      animation-iteration-count: infinite;
    }
  }

  @keyframes run-dots {
    from {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
}
</style>
